export const SOURCE_TYPES = {
  VIRGIN: 'virgin fossil-based',
  RECYCLED: 'post-consumer recycled',
} as const

export const PACKAGING_FORMS = {
  FLEXIBLE: 'flexible',
  RIGID: 'rigid',
} as const

export const PACKAGING_STATUSES = {
  FILLED: 'filled',
  UNFILLED: 'unfilled',
} as const

export const WASTE_STREAM_RESIDENTIAL = 'Residential'
export const WASTE_STREAM_ICI = 'ICI'
export const WASTE_STREAM_CDR = 'CDR'

export const WASTE_STREAMS = {
  [WASTE_STREAM_RESIDENTIAL]: 'Residential',
  [WASTE_STREAM_ICI]: 'Industrial, Commercial and Institutional (ICI)',
  [WASTE_STREAM_CDR]: 'Construction, Demolition, and Renovation (CDR)',
} as const

export const WASTE_STREAM_LABELS = {
  residential: 'Residential',
  ici: 'Industrial, Commercial and Institutional (ICI)',
  cdr: 'Construction, Demolition, and Renovation (CDR)',
} as const

export const WASTE_STREAM_VALUES = {
  RESIDENTIAL: WASTE_STREAM_RESIDENTIAL.toLowerCase(),
  ICI: WASTE_STREAM_ICI.toLowerCase(),
  CDR: WASTE_STREAM_CDR.toLowerCase(),
} as const

export type WasteStreamValue =
  (typeof WASTE_STREAM_VALUES)[keyof typeof WASTE_STREAM_VALUES]

export const PRODUCT_MATERIAL_TYPE_RAW_RESIN = 'RawResin'
export const PRODUCT_MATERIAL_TYPE_PLASTIC_PRODUCT = 'PlasticProduct'
export const PRODUCT_MATERIAL_TYPE_NON_PLASTIC = 'NonPlastic'
export const PRODUCT_MATERIAL_TYPE_UNDECLARED = 'Undeclared'

export type ProductMaterialType =
  | typeof PRODUCT_MATERIAL_TYPE_RAW_RESIN
  | typeof PRODUCT_MATERIAL_TYPE_PLASTIC_PRODUCT
  | typeof PRODUCT_MATERIAL_TYPE_NON_PLASTIC
  | typeof PRODUCT_MATERIAL_TYPE_UNDECLARED
